import * as yup from 'yup';

import { AddressFieldsFormFields } from 'src/constants/address';
import {
  ERROR_MESSAGE_REQUIRED_ZIP_CODE,
  emailValidationSchema,
  numberOfEmployeesSimpleValidationSchema,
  phoneNumberValidationSchema,
  taxYearEndDateSimpleValidationSchema,
  zipCodeValidationSchema,
} from 'src/constants/validation';
import { REQUIRED_VALIDATION_MESSAGE } from 'src/constants/validationMessage';

import { CompanyInformationFormPeoAdminFields } from '../types';

export const companyInformationFormPeoAdminValidationSchema = yup.object({
  [CompanyInformationFormPeoAdminFields.displayName]: yup
    .string()
    .nullable()
    .required(REQUIRED_VALIDATION_MESSAGE),
  [CompanyInformationFormPeoAdminFields.contactEmail]: emailValidationSchema
    .nullable()
    .required(REQUIRED_VALIDATION_MESSAGE),
  [CompanyInformationFormPeoAdminFields.contactPhoneNumber]: phoneNumberValidationSchema,
  [CompanyInformationFormPeoAdminFields.industry]: yup.string().nullable(),
  [CompanyInformationFormPeoAdminFields.corporateStructure]: yup.string().nullable(),
  [CompanyInformationFormPeoAdminFields.numberOfEmployees]: numberOfEmployeesSimpleValidationSchema,
  [CompanyInformationFormPeoAdminFields.taxYearEndDate]: taxYearEndDateSimpleValidationSchema,
  [CompanyInformationFormPeoAdminFields.defaultDisclaimer]: yup.string().nullable(),
  [CompanyInformationFormPeoAdminFields.headquarters]: yup.object({
    [AddressFieldsFormFields.street]: yup.string().required('Required street'),
    [AddressFieldsFormFields.city]: yup.string().required('Required city'),
    [AddressFieldsFormFields.county]: yup.string().nullable(),
    [AddressFieldsFormFields.state]: yup.string().required('Required state'),
    [AddressFieldsFormFields.zipCode]: zipCodeValidationSchema.required(
      ERROR_MESSAGE_REQUIRED_ZIP_CODE,
    ),
  }),
  [CompanyInformationFormPeoAdminFields.fein]: yup
    .string()
    .nullable()
    .test('invalid-fein', 'Invalid FEIN', value => !Number.isNaN(Number(value)))
    .length(9, 'Invalid FEIN')
    .required('Required'),
});
